module.exports = __webpack_public_path__ + "img/224f0c1.svg";